import React from "react";
import ReactDOM from 'react-dom/client';
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";
import "./i18n";
import { Provider } from "react-redux";

import { store, persistor } from "./store";
import { PersistGate } from 'redux-persist/integration/react'
import { ToastProvider } from "ToastStore";
import { MsalProvider } from "@azure/msal-react";
import msalInstance from "../src/pages/auth/msalConfig";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <React.Fragment>
        <BrowserRouter>
          <ToastProvider>
            <MsalProvider instance={msalInstance}>
              <App />
            </MsalProvider>,
          </ToastProvider>
        </BrowserRouter>
      </React.Fragment>
    </PersistGate>
  </Provider>
);

serviceWorker.unregister()
